// EstadaTemporaria.js
import React from "react";
import styled from "styled-components";

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${props => props.active ? "linear-gradient(135deg, #151c48, #2a3a8f)" : "linear-gradient(135deg, #f0f4ff, #d9e7ff)"};
  border-radius: 16px;
  box-shadow: ${props => props.active ? "0 15px 30px rgba(21, 28, 72, 0.3)" : "0px 10px 25px rgba(0, 0, 0, 0.1)"};
  padding: 30px 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 100%;
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.2);
  }
`;

const CardIcon = styled.div`
  width: 80px;
  height: 80px;
  background: ${props => props.active ? "#5ab9d3" : "linear-gradient(135deg, #0066ff, #0099ff)"};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 2.5rem;
  margin-bottom: 15px;
  box-shadow: 0px 4px 15px rgba(0, 102, 255, 0.3);
  transition: all 0.3s ease;
`;

const CardTitle = styled.h2`
  font-size: 1.5rem;
  color: ${props => props.active ? "#ffffff" : "#333"};
  font-weight: 600;
  margin-top: 10px;
  line-height: 1.4;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
`;

const Subtitle = styled.p`
  font-size: 0.9rem;
  color: ${props => props.active ? "rgba(255,255,255,0.8)" : "#666"};
  margin-top: 8px;
  line-height: 1.6;
  transition: all 0.3s ease;
`;

function EstadaTemporaria({ active }) {
  return (
    <Card active={active}>
      <CardIcon active={active}>💼</CardIcon>
      <CardTitle active={active}>Estadia Temporária</CardTitle>
      <Subtitle active={active}>Informações sobre estadias temporárias em Portugal</Subtitle>
    </Card>
  );
}

export default EstadaTemporaria;